import { memo } from 'react';

import { SvgIconProps } from './SvgIcon.types';

export const RichSearchIcon = memo(({ fontSize = 24 }: SvgIconProps) => (
  <svg width={fontSize} height={fontSize} viewBox="0 0 115 115" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M45.6751 68.7153C59.273 68.7153 70.2963 57.6775 70.2963 44.0617C70.2963 30.4459 59.273 19.4082 45.6751 19.4082C32.0772 19.4082 21.054 30.4459 21.054 44.0617C21.054 57.6775 32.0772 68.7153 45.6751 68.7153Z"
      fill="#E8EFEA"
    />
    <path
      d="M112.623 101.726L82.398 71.4612C87.2864 64.477 90.148 55.9408 90.148 46.8076C90.148 22.9301 70.773 3.46989 46.8672 3.46989C23.021 3.46989 3.58643 22.8704 3.58643 46.748C3.58643 70.6255 22.9614 90.0857 46.8672 90.0857C56.1672 90.0857 64.7518 87.101 71.846 82.1464L102.071 112.352C103.502 113.784 105.35 114.56 107.377 114.56C109.404 114.56 111.252 113.784 112.683 112.352C114.113 110.919 114.888 109.068 114.888 107.039C114.829 105.009 114.054 103.159 112.623 101.726ZM46.8672 80.7735C28.148 80.7735 12.946 65.5515 12.946 46.8076C12.946 28.0638 28.148 12.8418 46.8672 12.8418C65.5864 12.8418 80.7884 28.0638 80.7884 46.8076C80.7884 65.5515 65.5864 80.7735 46.8672 80.7735Z"
      fill="#F1CAA4"
    />
    <path
      d="M43.8269 86.2653C67.2034 86.2653 86.1539 67.2899 86.1539 43.8827C86.1539 20.4754 67.2034 1.5 43.8269 1.5C20.4504 1.5 1.5 20.4754 1.5 43.8827C1.5 67.2899 20.4504 86.2653 43.8269 86.2653Z"
      stroke="#E87524"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.827 76.953C62.0672 76.953 76.8539 62.1469 76.8539 43.8826C76.8539 25.6184 62.0672 10.8122 43.827 10.8122C25.5867 10.8122 10.8 25.6184 10.8 43.8826C10.8 62.1469 25.5867 76.953 43.827 76.953Z"
      stroke="#E87524"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.8269 19.4082C54.9154 19.4082 64.3346 26.8102 67.2558 36.9582"
      stroke="#226937"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88.1211 78.6245L78.7615 87.9367"
      stroke="#226937"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M68.5078 42.8082C69.0016 42.8082 69.402 42.4073 69.402 41.9128C69.402 41.4182 69.0016 41.0173 68.5078 41.0173C68.0139 41.0173 67.6135 41.4182 67.6135 41.9128C67.6135 42.4073 68.0139 42.8082 68.5078 42.8082Z"
      fill="#026A37"
    />
    <path
      d="M78.225 68.7153L108.987 99.5173C111.55 102.084 111.55 106.263 108.987 108.889C106.423 111.456 102.25 111.456 99.627 108.889L68.925 78.1469"
      stroke="#E87524"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
